<template>
    <main>
      <projects/>

      <div class="hm-sec-top-outer">
        <div class="hm-sec-top-inner content-box">
          <h2 class="hm-sec-ttl">Your Creative Partner</h2>
          <p>We work with clients for an extended period of time. We offer everything we’ve got, to make each project custom-tailored and polished to the last detail. Say hello to being a trail-blazer in your industry.</p>
          <!-- <p>We work with clients for an extended period dedicated to their business.</p>
          <p>This is how we can offer all we got to make each project custom trailered and</p>
          <p>polished to the smallest detail.</p> -->
        </div>
      </div>

      <home-section
        :section="{
          left:true,
          title:'Our Process',
          subTitle:'Plan',
          text:'Getting the full picture of a business is vital to the success of the project. Our in depth research of your market culminates in software that works- presently and after future growth too.'
        }"
      >
        <template v-slot:right>
          <div class="hm-sec-img plan-img1">
            <img v-observe-visibility="{
              callback: visibilityChanged,
              once: true,
              intersection: {
                rootMargin: '0px',
                threshold: 0.7,
              },
            }" width="1222" height="914" class="fade" src="../assets/img/plan.png" alt="Our Process">
            <div style="top:10%;left:-1%;" class="hm-badge fadeUp delay-250"><img src="../assets/img/greenchek.svg">Research Market</div>
            <div style="right:-1%;bottom:41%;" class="hm-badge fadeUp delay-500"><img src="../assets/img/greenchek.svg">Unique Features</div>
            <div style="bottom:18%;left:8%;" class="hm-badge fadeUp delay-750"><img src="../assets/img/greenchek.svg">Sitemap Planning</div>
          </div>
        </template>
      </home-section>

      <home-section
        :section="{
          right:true,
          subTitle:'Design',
          text:'We’re a design first company. Establish your identity in a professional way and with breathtaking design. We create a satisfying user experience for the front end and back end.'
        }"
      >
        <template v-slot:left>
          <div class="hm-sec-img design-img1">
            <img 
              v-observe-visibility="{
                callback: visibilityChanged,
                once: true,
                intersection: {
                  rootMargin: '0px',
                  threshold: 0.7,
                },
              }" width="1222" height="914" class="fade" src="../assets/img/design1.png" alt="Design">
            <div class="design-img2 fadeUp delay-250"><img src="../assets/img/design2.png"></div>
            <div class="design-img3 fadeUp delay-500"><img src="../assets/img/design3.svg"></div>
          </div>
        </template>
      </home-section>

      <home-section
        :section="{
          left:true,
          subTitle:'Build',
          text:'Super clean code gets you speed software and easily maintainable software. We aim to write code that humans can relate to and that software can process precisely.'
        }"
      >
        <template v-slot:right>
          <div class="hm-sec-img build-img1">
            <img 
              v-observe-visibility="{
                  callback: visibilityChanged,
                  once: true,
                  intersection: {
                    rootMargin: '0px',
                    threshold: 0.7,
                  },
                }"
            width="1222" height="914" class="fade" src="../assets/img/build1.svg" alt="Build">
            <div class="build-img2 fadeUp delay-250"><img src="../assets/img/build2.png"></div>
          </div>
        </template>
      </home-section>

      <home-section
        style="padding-bottom:5%"
        :section="{
          right:true,
          subTitle:'Launch',
          text:'Launch-day is party time, but it doesn’t end there. Our team is dedicated to monitoring projects and constantly improving user experience.'
        }"
      >
        <template v-slot:left>
          <div class="hm-sec-img launch-img1">
            <img 
              v-observe-visibility="{
                callback: visibilityChanged,
                once: true,
                intersection: {
                  rootMargin: '0px',
                  threshold: 0.7,
                },
              }"
            width="1222" height="914" class="fade" src="../assets/img/launch1.png" alt="Launch">
            <div class="launch-img2 fadeUp delay-250"><img src="../assets/img/launch2.png"></div>
            <div class="launch-img3 fadeUp delay-500"><img src="../assets/img/launch3.svg"></div>
          </div>
        </template>
      </home-section>

      <div class="hm-sec-bot-outer">
        <div class="hm-sec-bot-inner content-box">
          <div class="hm-sec-bot-img">
            <img width="496" height="604" src="../assets/img/BezalelCareCfo.svg" alt="BezalelCareCfo">
          </div>
          <div class="hm-sec-bot-txt">
            <p>What began as a confusing jumble of ideas for our organization’s identity and branding, was rapidly and masterfully turned into a work of art by the team at Capital C. We are continuously amazed at the concepts and creations that they produce for us.</p>
            <div class="hm-sec-bot-txt-cfo">
              <img width="496" height="604" src="../assets/img/BezalelCareCfo.svg" alt="BezalelCareCfo">
              <div>
                <p>Joshua Bosch</p>
                <p>Managing Partner, Bezalel Rehabilitation & Nursing Center</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <home-footer
        :background="'#161717'"
        :color="'#FFFFFF'"
      />
    </main>
</template>

<script>
import Projects from '../components/home/Projects'
import Section from '../components/home/Section'
import Footer from '../components/footer/Footer'
export default {
  name: 'Home',

  methods:{
    visibilityChanged(isVisible, entry){
      entry.target.setAttribute('data-isVisible',isVisible)
    }
  },

  components:{
    Projects,
    HomeSection:Section,
    HomeFooter:Footer
  }
}
</script>

<style>
.hm-sec-top-outer{
  background: #EDEDED;
  text-align: center;
}

.hm-sec-top-inner{
  padding-top: 110px !important;
  padding-bottom: 110px !important;
}

.hm-sec-top-inner p{
  font-size: 24px;
  line-height: 40px;
  font-weight: 300;
  color: #525252;
}

.hm-sec-img{
  position: relative;
}

.hm-sec-img img{
  max-width: 100%;
  height: auto;
  object-fit: contain;
}

.plan-img1{
  width: 100%;
}

.hm-badge{
  background: #FFFFFF;
  border-radius: 10px;
  box-shadow: 0px 3px 6px #00000029;
  padding: 7px 17px 7px 13px;
  position: absolute;
  color: black;
  font-size: 17px;
  display: flex;
  justify-content: space-between;
  font-weight: 500;
  align-items: center;
  user-select: none;
}

.hm-badge img{
  height: 20px;
  width: 20px;
  margin-right: 20px;
}

.design-img2,
.design-img3{
  position: absolute;
}

.design-img1{
  width: 88.2%;
}

.design-img2{
  width: 27.5%;
  bottom: -4%;
  right: -4%;
}

.design-img3{
  top: 17%;
  left: -1%;
  width: 13%;
}

.build-img1{
  width: 80.8%;
}

.build-img2{
  position: absolute;
  bottom: -15%;
  width: 99%;
  right: -11%;
}

.launch-img2,
.launch-img3{
  position: absolute;
}

.launch-img1{
  width: 91.7%;
}

.launch-img2{
  top: -5%;
  right: -12%;
  width: 108%;
}

.launch-img3{
  width: 60%;
  bottom: -12%;
  left: -9%;
}

.hm-sec-bot-outer{
  background: #EDEDED;
}

.hm-sec-bot-inner{
  padding: 107px 90px 107px 90px !important;
  display: flex;
  align-items: center;
}

.hm-sec-bot-img{
  width: 286px;
  height: 160px;
  margin-right: 64px;
  flex: 0 0 230px;
  margin-bottom: auto;
}

.hm-sec-bot-img img{
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.hm-sec-bot-txt > p{
  line-height: 44px;
  font-weight: 300;
  margin-bottom: 21px;
  font-size: 26px;
}

.hm-sec-bot-txt-cfo img{
  display: none;
}

.hm-sec-bot-txt-cfo p{
  line-height: 35px;
}

.hm-sec-bot-txt-cfo p:nth-child(1){
  font-weight: 400;
  font-size: 27px;
}

.hm-sec-bot-txt-cfo p:nth-child(2){
  font-weight: 400;
  color: #707070;
  font-size: 21px;
}

@media screen and (max-width: 1366px){
  .hm-sec-top-inner{
    padding-top: 73px !important;
    padding-bottom: 73px !important;
  }

  .hm-sec-top-inner p{
    font-size: 18px;
    line-height: 29px;
  }

  .hm-badge{
    padding: 7px 17px 7px 13px;
    font-size: 12px;
  }

  .hm-badge img{
    height: 15px;
    width: 15px;
    margin-right: 15px;
  }

  .design-img1 {
    width: 93.2%;
  }

  .hm-sec-bot-inner{
    padding: 75px 90px 75px 31px !important;
  }

  .hm-sec-bot-img{
    width: 193px;
    height: 235px;
    margin-right: 53px;
    flex: 0 0 193px;
  }

  .hm-sec-bot-txt > p{
    line-height: 33px;
    margin-bottom: 19px;
    font-size: 20px;
  }

  .hm-sec-bot-txt-cfo p{
    line-height: 23px;
  }

  .hm-sec-bot-txt-cfo p:nth-child(1){
    font-size: 20px;
  }

  .hm-sec-bot-txt p:nth-child(2){
    font-size: 15px;
  }
}

@media screen and (max-width: 800px){
  .hm-sec-top-inner{
    padding-top: 48px !important;
    padding-bottom: 48px !important;
  }

  .hm-badge{
    padding: 7px 17px 7px 13px;
    font-size: 17px;
  }

  .hm-badge img{
    height: 20px;
    width: 20px;
    margin-right: 20px;
  }

  .launch-img1,
  .build-img1{
    margin-bottom: 28px;
  }

  .hm-sec-bot-inner{
    padding: 44px 20px 44px 20px !important;
  }

  .hm-sec-bot-img{
    display: none;
  }

  .hm-sec-bot-txt-cfo{
    display: flex;
    align-items: center;
  }

  .hm-sec-bot-txt-cfo img{
    display: inline-block;
    width: 64px;
    height: 78px;
    margin-right: 23px;
  }
}

@media screen and (max-width: 589px){
  .hm-sec-top-inner p{
    font-size: 16px;
    line-height: 24px;
  }

  .hm-badge{
    padding: 7px 10px 7px 10px;
    font-size: 11px;
  }

  .hm-badge img{
    height: 12px;
    width: 12px;
    margin-right: 12px;
  }

  .hm-sec-bot-inner{
    padding: 53px 11px 53px 11px !important;
  }

  .hm-sec-bot-txt > p{
    line-height: 30px;
    margin-bottom: 19px;
    font-size: 17px;
  }

}
</style>
